import { multipleSelect } from 'multiple-select-vanilla';

// Collapses the interest-registration panel's Multi-Select into a dropdown. Freeform still renders
// the native `<select multiple name="handle[]">` underneath, so submissions are unchanged.
function initPanelMultiSelects() {
    document.querySelectorAll('.rtm-panel-multiselect select[multiple]').forEach((select) => {
        if (select.dataset.msInitialised) {
            return;
        }

        select.dataset.msInitialised = 'true';

        // The panel's `z-0` traps the open dropdown in its stacking context, so the next panel
        // paints over it.
        const panel = select.closest('.interest-registration-panel');

        const instance = multipleSelect(select, {
            selectAll: false,
            width: '100%',
            onOpen: () => panel?.classList.replace('z-0', 'z-20'),
            onClose: () => panel?.classList.replace('z-20', 'z-0'),
        });

        // Freeform resets the form after a successful submit, but that only clears the native
        // select — the dropdown keeps its own state and would still show the old selection.
        const form = select.closest('form');

        ['reset', 'freeform-on-reset'].forEach((event) => {
            form?.addEventListener(event, () => instance.uncheckAll());
        });

        // The library sizes .ms-parent off the select's inline width (same fix as the What's On filters).
        const parent = select.closest('.rtm-panel-multiselect')?.querySelector('.ms-parent');

        if (parent) {
            parent.style.width = '';
        }
    });
}

// The theme bundle is loaded async, so DOMContentLoaded has usually already fired by now.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPanelMultiSelects);
} else {
    initPanelMultiSelects();
}
